// extracted by mini-css-extract-plugin
export var arrow = "bs_9";
export var body = "bs_c";
export var circle = "bs_fy";
export var customer = "bs_fx";
export var feedback = "bs_fw";
export var feedbacks = "bs_ft";
export var footer = "bs_ch";
export var footerText = "bs_cj";
export var left = "bs_bN";
export var nameLocation = "bs_fz";
export var padding = "bs_dD";
export var right = "bs_cl";
export var section = "bs_d";
export var selected = "bs_bg";
export var selectors = "bs_fs";
export var subtitle = "bs_cV";
export var text = "bs_b6";
export var title = "bs_h";
export var wrapper = "bs_fv";